<div
  class="tw-flex tw-flex-col tw-p-6 tw-mx-auto tw-max-w-lg tw-text-center tw-text-gray-900 tw-bg-white dark:tw-bg-gray-800 tw-rounded-lg tw-border tw-border-gray-100 dark:tw-border-gray-400 xl:tw-p-8"
  [ngClass]="{ 'tw-border-solid tw-shadow': !isDialog }">
  <h3 *ngIf="isDialog" class="tw-text-2xl tw-font-semibold tw-mb-6 tw-text-dark-light-dynamic">
    Upgrade Your People Data Plan
  </h3>

  <h3 *ngIf="!isDialog" class="tw-text-2xl tw-font-semibold tw-mb-6 tw-text-dark-light-dynamic">
    People Data Subscription
  </h3>

  <ul role="list" class="tw-mb-4 tw-space-y-2 tw-text-left">
    <li class="tw-flex tw-items-center tw-space-x-3">
      <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
      <span class="tw-text-dark-light-dynamic">Access to all People and jobs fields</span>
    </li>
    <li class="tw-flex tw-items-center tw-space-x-3">
      <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
      <span class="tw-text-dark-light-dynamic">API and Dashboard reports and alerts</span>
    </li>
    <li class="tw-flex tw-items-center tw-space-x-3">
      <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
      <span class="tw-text-dark-light-dynamic">Delivery for machine or human consumption</span>
    </li>
    <li class="tw-flex tw-items-center tw-space-x-3">
      <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
      <span class="tw-text-dark-light-dynamic">
        Unlimited filter sets with real-time change notifications
      </span>
    </li>
  </ul>

  <ng-container *ngIf="isLoadingPrices">
    <div class="tw-flex tw-justify-center tw-items-center tw-py-8">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoadingPrices">
    <!-- Tiers Section -->
    <div class="tw-my-6">
      <h4 class="tw-text-lg tw-font-semibold tw-mb-3 tw-text-dark-light-dynamic tw-mt-0">
        {{ isDialog ? 'Select New Tier' : 'Select Tier' }}
      </h4>

      <!-- Tiers grid -->
      <div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-mb-4">
        <!-- free tier hardcoded -->
        <button
          [ngClass]="
          {
            'tw-bg-primary_purple-500 dark:tw-bg-teal-700 tw-bg-opacity-30 dark:tw-bg-opacity-15 tw-border-link-color-dynamic-darker tw-text-link-color-dynamic': currentPriceId === null,
            'tw-bg-blue-100 dark:tw-bg-blue-700 dark:tw-bg-opacity-20 tw-border-blue-500 tw-text-blue-500': selectedPriceId === null && currentPriceId !== null,
            'tw-border-gray-200 dark:tw-border-gray-600 tw-bg-white dark:tw-bg-gray-800 tw-text-dark-light-dynamic': selectedPriceId !== null && currentPriceId !== null,
          }"
          class="tw-p-2 tw-border tw-border-solid tw-rounded-md tw-transition-all hover:tw-bg-gray-50 dark:hover:tw-bg-gray-700"
          (click)="selectTier(null)">
          <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
            <span class="tw-font-semibold">500</span>
            <span class="tw-text-gray-500 dark:tw-text-gray-400">/</span>
            <span class="tw-text-gray-500 dark:tw-text-gray-400"> Free </span>
          </div>
        </button>

        <!-- paid tiers based on sortedPrices -->
        <ng-container *ngFor="let price of sortedPrices">
          <button
            *ngIf="price.qty <= 200000"
            [ngClass]="{
              'tw-bg-primary_purple-500 dark:tw-bg-teal-700 tw-bg-opacity-30 dark:tw-bg-opacity-15 tw-border-link-color-dynamic-darker tw-text-link-color-dynamic': currentPriceId === price.priceId,
              'tw-bg-blue-100 dark:tw-bg-blue-700 dark:tw-bg-opacity-20 tw-border-blue-500 tw-text-blue-500': selectedPriceId === price.priceId && currentPriceId !== price.priceId,
              'tw-border-gray-200 dark:tw-border-gray-600 tw-bg-white dark:tw-bg-gray-800 tw-text-dark-light-dynamic': selectedPriceId !== price.priceId
            }"
            class="tw-p-2 tw-border tw-border-solid tw-rounded-md tw-transition-all hover:tw-bg-gray-50 dark:hover:tw-bg-gray-700"
            (click)="selectTier(price.priceId)">
            <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
              <span class="tw-font-semibold">{{price.qty | number}}</span>
              <span class="tw-text-gray-500 dark:tw-text-gray-400">/</span>
              <span class="tw-text-gray-500 dark:tw-text-gray-400">
                {{price.price | currency:'USD':'symbol':'1.0-0'}}
              </span>
            </div>
          </button>
        </ng-container>

        <!-- 50k+ tier hardcoded -->
        <button
          class="tw-p-2 tw-border tw-border-solid tw-rounded-md tw-transition-all hover:tw-bg-gray-50 dark:hover:tw-bg-gray-700 tw-col-span-2
          tw-border-gray-200 dark:tw-border-gray-600 tw-bg-white dark:tw-bg-gray-800 tw-text-dark-light-dynamic"
          (click)="openIntercomForSales()">
          <div class="tw-font-semibold">200k+</div>
          <div class="tw-text-dark-light-dynamic tw-mt-1">Contact sales</div>
        </button>
      </div>
    </div>

    <ng-container
      *ngIf="currentPriceId !== null && selectedPriceId === null && (isOrgAdmin$ | async)">
      <app-alert alertType="warning">
        <span class="tw-text-base">
          Canceling your subscription will take effect at the end of your current billing period.
          Until then your existing credits remain available.
        </span>
      </app-alert>
      <a
        (click)="cancelSubscription()"
        class="tw-mt-6 tw-text-white tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-sm tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-from-blue-600 hover:tw-to-purple-600 focus:tw-outline-none focus:tw-ring-blue-500 tw-transition-all tw-p-0.5 tw-cursor-pointer">
        <span class="tw-relative tw-w-full tw-px-5 tw-py-2.5 tw-rounded-md tw-font-semibold">
          Cancel Subscription
        </span>
      </a>
    </ng-container>

    <ng-container
      *ngIf="currentPriceId !== null && selectedPriceId !== null  && (isOrgAdmin$ | async)">
      <app-alert alertType="info" *ngIf="currentPriceId !== selectedPriceId">
        <span class="tw-text-base">
          Changing now won't prorate your current subscription. Rather, a new subscription will
          start immediately at the new price and your prior credits will remain available until the
          end of that term. Your usage will be allocated to the prior subscription first and then
          will switch to your new subscription allocation and billing period.
        </span>
      </app-alert>
      <a
        [ngClass]="{
          'tw-opacity-50': !allowChangeSubscription(),
          'tw-cursor-not-allowed': !allowChangeSubscription(),
          'tw-cursor-pointer': allowChangeSubscription()
        }"
        (click)="allowChangeSubscription() && updateSubscription()"
        [attr.disabled]="!allowChangeSubscription()"
        class="tw-mt-6 tw-text-white tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-sm tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-from-blue-600 hover:tw-to-purple-600 focus:tw-outline-none focus:tw-ring-blue-500 tw-transition-all tw-p-0.5 tw-cursor-pointer">
        <span class="tw-relative tw-w-full tw-px-5 tw-py-2.5 tw-rounded-md tw-font-semibold">
          Change Subscription
        </span>
      </a>
    </ng-container>

    <ng-container *ngIf="currentPriceId === null && (isOrgAdmin$ | async)">
      <a
        (click)="selectedPriceId && subscribe()"
        [ngClass]="{
          'tw-opacity-50': !selectedPriceId,
          'tw-cursor-not-allowed': !selectedPriceId,
          'tw-cursor-pointer': selectedPriceId
        }"
        class="tw-mt-6 tw-text-white tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-sm tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-from-blue-600 hover:tw-to-purple-600 focus:tw-outline-none focus:tw-ring-blue-500 tw-transition-all tw-p-0.5">
        <span class="tw-relative tw-w-full tw-px-5 tw-py-2.5 tw-rounded-md tw-font-semibold">
          Subscribe
        </span>
      </a>
    </ng-container>
  </ng-container>
  <div
    class="tw-pt-4"
    *ngIf="currentPriceId !== null && selectedPriceId !== null && (isOrgAdmin$ | async)">
    <a (click)="cancelSubscription()" class="tw-text-red-500 tw-text-sm">Cancel Subscription</a>
  </div>

  <ng-container *ngIf="!(isOrgAdmin$ | async)">
    <app-alert alertType="info">
      You must be an administrator to manage your subscription.
    </app-alert>
  </ng-container>
</div>
